import { Component, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../base/base-component.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    template: '',
    selector: 'angular-core-abstract-modal-base',
    standalone: false,
})
export abstract class AbstractModalBase extends BaseComponent {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    abstract openModal(parameter?: any): void;

    abstract get modalId(): string;

    @Output() onCloseEvent: EventEmitter<boolean> = new EventEmitter();

    protected open(): void {
        $('#' + this.modalId).dialog('open');
    }

    protected init(height?: number, width?: number, option?: any): void {
        if (!option) {
            option = {
                autoOpen: false,
                resizable: false,
                modal: true,
            };
        }
        if (height) {
            option.height = height;
        }
        if (width) {
            option.width = width;
        }
        $('#' + this.modalId).dialog(option);
    }

    public save(): void {
        this.onCloseEvent.emit(true);
        $('#' + this.modalId).dialog('close');
    }

    public close(): void {
        this.onCloseEvent.emit(false);
        $('#' + this.modalId).dialog('close');
    }
}
